
<div class="flow-countdown-wrapper">
	<div v-if="showLabel && remaining > 0" class="flow-countdown-label">
		<Typography type="p1" weight="medium" color="dark"> {{ remaining }}s </Typography>
	</div>
	<div v-if="remaining > 0" class="flow-countdown-circle" :style="circle">
		<div class="flow-countdown-pie flow-countdown-spinner" :style="spinner" />
		<div class="flow-countdown-pie flow-countdown-filler" :style="filler" />
		<div class="mask" :style="mask" />
	</div>
</div>
